import { defineSemanticTokens, defineTokens } from '@chakra-ui/react'

// --- Primitive token categories (source of truth in the individual .ts files below) ---
import { colors as semanticColors } from '../semantic-tokens/colors'
import { radii as semanticRadii } from '../semantic-tokens/radii'
import { shadows as semanticShadows } from '../semantic-tokens/shadows'
import { animations } from './animations'
import { aspectRatios } from './aspect-ratios'
import { blurs } from './blurs'
import { borders } from './borders'
import { colors } from './colors'
import { cursor } from './cursor'
import { durations } from './durations'
import { easings } from './easings'
import { fontSizes } from './font-sizes'
import { fontWeights } from './font-weights'
import { fonts } from './fonts'
import { letterSpacings } from './letter-spacings'
import { lineHeights } from './line-heights'
import { radii } from './radii'
import { sizes } from './sizes'
import { spacing } from './spacing'
import { zIndex } from './z-index'

// --- Generated semantic token categories ---

// Apply sco-specific overrides on top of the generated Figma values.
// These overrides were previously done via deepmerge against the monolithic figma-tokens.ts.
export const tokens = {
  tokens: defineTokens({
    animations,
    aspectRatios,
    blurs,
    colors,
    cursor,
    durations,
    easings,
    spacing,
    sizes,
    radii,
    borders,
    zIndex,
    fonts,
    fontSizes,
    fontWeights,
    lineHeights,
    letterSpacings,
  }),
  semanticTokens: defineSemanticTokens({
    colors: semanticColors,
    radii: semanticRadii,
    shadows: semanticShadows,
  }),
}
